/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pictureLeftAside.vue?vue&type=template&id=79045b83&scoped=true&"
import script from "./pictureLeftAside.vue?vue&type=script&lang=js&"
export * from "./pictureLeftAside.vue?vue&type=script&lang=js&"
import style0 from "./pictureLeftAside.vue?vue&type=style&index=0&id=79045b83&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79045b83",
  null
  
)

export default component.exports